import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import checkedCircle from 'Shared/img/checked-circle.png'

import { ReviewSentSuccessProps } from './props'
import {
  Container,
  ButtonsContainer,
  MessageContainer,
  SuccessIcon,
  SuccessText,
  Button,
} from './styles'

export const ReviewSentSuccess: FunctionComponent<ReviewSentSuccessProps> = ({
  skipFlow,
  onCloseSucccess,
}) => {
  const { t } = useTranslation()

  return (
    <Container>
      <MessageContainer>
        <SuccessIcon src={checkedCircle} />
        <SuccessText>
          {skipFlow
            ? t('reviewsPage.skipSuccessReview')
            : t('reviewsPage.sendSuccessReview')}
        </SuccessText>
      </MessageContainer>
      <ButtonsContainer>
        <Button onClick={onCloseSucccess}>{t('reviewsPage.close')}</Button>
      </ButtonsContainer>
    </Container>
  )
}
